import { useState } from "react";
import { Container, Row, Col, Card, Button, Alert, Toast } from "react-bootstrap";

import * as S from "./styled";
import Template from "../../template";
import { useAuth } from "../../context/auth";

const Suporte = () => {
  const [openFAQItems, setOpenFAQItems] = useState({});
  const [showCopyToast, setShowCopyToast] = useState(false);
  const SUPPORT_EMAIL = 'cursodaniellevelasco@gmail.com';
  const { user } = useAuth();

  const handleCopyEmail = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(SUPPORT_EMAIL);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = SUPPORT_EMAIL;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      setShowCopyToast(true);
    } catch (err) {
      setShowCopyToast(false);
    }
  };

  const toggleFAQItem = (index) => {
    setOpenFAQItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  const faqPlans = ['PREMIUM', 'VIP', 'PLUS', 'ESSENCIAL'];
  const showQuickFAQ = (user?.nivel === 'e' || user?.nivel === 't') && faqPlans.includes(user?.plano);
  return (
    <Template>
      {/* Toast sobreposto para feedback de cópia */}
      <div style={{ position: 'fixed', top: 96, right: 16, zIndex: 1060 }}>
        <Toast
          show={showCopyToast}
          onClose={() => setShowCopyToast(false)}
          delay={2000}
          autohide
          className="bg-success text-white shadow"
        >
          <Toast.Body role="status" aria-live="polite">
            <i className="fas fa-check-circle me-2"></i>
            <span className="pl-2">E-mail copiado para a área de transferência</span>
          </Toast.Body>
        </Toast>
      </div>
      <S.MainWrapper>
        <Container>
          <S.MainContent>
            <Row className="justify-content-center">
              <Col lg={8} md={10}>
                <div className="text-center mb-4">
                  <S.FAQTitle>CENTRAL DE SUPORTE</S.FAQTitle>
                  <p className="text-muted">
                    Estamos aqui para ajudar! Entre em contato conosco através dos canais abaixo.
                  </p>
                </div>

                {/* Contatos Principais */}
                <Row className="mb-4">
                  <Col md={6} className="mb-3">
                    <Card className="h-100 shadow-sm border-0">
                      <Card.Body className="text-center p-4">
                        <div className="mb-3">
                          <i className="fab fa-whatsapp text-success" style={{ fontSize: '2.5rem' }}></i>
                        </div>
                        <h5 className="card-title">WhatsApp</h5>
                        <p className="text-muted mb-3">
                          Atendimento rápido e direto
                        </p>
                        <p className="h6 mb-3">(21) 96957-0209</p>
                        <Button
                          variant="success"
                          href="https://wa.me/5521969570209"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="w-100"
                        >
                          <i className="fab fa-whatsapp me-2"></i>
                          <span className="pl-2">Abrir WhatsApp</span>
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md={6} className="mb-3">
                    <Card className="h-100 shadow-sm border-0">
                      <Card.Body className="text-center p-4">
                        <div className="mb-3">
                          <i className="fas fa-envelope text-primary" style={{ fontSize: '2.5rem' }}></i>
                        </div>
                        <h5 className="card-title">E-mail</h5>
                        <p className="text-muted mb-3">
                          Para dúvidas mais detalhadas
                        </p>
                        <p className="h6 mb-3">{SUPPORT_EMAIL}</p>
                        <Button
                          variant="primary"
                          className="w-100"
                          onClick={handleCopyEmail}
                          title="Copiar e-mail para a área de transferência"
                        >
                          <i className="fas fa-copy me-2"></i>
                          <span className="pl-2">Copiar e-mail</span>
                          
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                {/* Horário de Atendimento */}
                <Card className="shadow-sm border-0 mb-4">
                  <Card.Body className="p-4">
                    <h5 className="card-title mb-3">
                      <i className="fas fa-clock me-2 text-info "></i>
                      <span className="pl-2">Horário de Atendimento</span>
                    </h5>
                    <Row>
                      <Col md={6}>
                        <p className="mb-2">
                          <strong>Segunda a Sexta:</strong> 8h às 20h
                        </p>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                {showQuickFAQ && (
                  <S.FAQSection>
                    <S.FAQContent>
                      <S.FAQTitle>PERGUNTAS FREQUENTES</S.FAQTitle>
                      
                      <S.FAQContainer>
                        <S.FAQItem>
                          <S.FAQQuestion onClick={() => toggleFAQItem(0)}>
                            <S.FAQQuestionText>Em quanto tempo recebo a correção?</S.FAQQuestionText>
                            <S.FAQIcon isOpen={openFAQItems[0]}>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"/>
                              </svg>
                            </S.FAQIcon>
                          </S.FAQQuestion>
                          {openFAQItems[0] && (
                            <S.FAQAnswer>
                              <S.FAQAnswerText>
                                Sua redação é corrigida em até 2 minutos pela nossa IA especializada! 
                                Você recebe uma análise completa e detalhada de todas as competências do ENEM, 
                                com sugestões personalizadas para melhorar sua escrita.
                              </S.FAQAnswerText>
                            </S.FAQAnswer>
                          )}
                        </S.FAQItem>

                        <S.FAQItem>
                          <S.FAQQuestion onClick={() => toggleFAQItem(1)}>
                            <S.FAQQuestionText>Posso cancelar quando quiser?</S.FAQQuestionText>
                            <S.FAQIcon isOpen={openFAQItems[1]}>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"/>
                              </svg>
                            </S.FAQIcon>
                          </S.FAQQuestion>
                          {openFAQItems[1] && (
                            <S.FAQAnswer>
                              <S.FAQAnswerText>
                                Oferecemos garantia de 7 dias a partir da contratação:
                                se você não ficar satisfeito com o serviço nesse período, devolvemos 100% do valor pago, sem necessidade de justificativa.
                              </S.FAQAnswerText>
                            </S.FAQAnswer>
                          )}
                        </S.FAQItem>

                        <S.FAQItem>
                          <S.FAQQuestion onClick={() => toggleFAQItem(3)}>
                            <S.FAQQuestionText>Preciso escrever toda semana?</S.FAQQuestionText>
                            <S.FAQIcon isOpen={openFAQItems[3]}>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"/>
                              </svg>
                            </S.FAQIcon>
                          </S.FAQQuestion>
                          {openFAQItems[3] && (
                            <S.FAQAnswer>
                              <S.FAQAnswerText>
                                Não há obrigatoriedade! Você escreve no seu ritmo e quando quiser. 
                                Recomendamos pelo menos 1-2 redações por semana para um progresso consistente, 
                                mas você tem total flexibilidade para usar suas correções quando for melhor para você.
                              </S.FAQAnswerText>
                            </S.FAQAnswer>
                          )}
                        </S.FAQItem>

                      </S.FAQContainer>
                    </S.FAQContent>
                  </S.FAQSection>
                )}

                {/* Aviso de Resposta */}
                <Alert variant="info" className="text-center">
                  <i className="fas fa-info-circle me-2"></i>
                  <strong>Tempo de resposta:</strong> Respondemos todas as mensagens em até 24 horas úteis.
                </Alert>
              </Col>
            </Row>
          </S.MainContent>
        </Container>
      </S.MainWrapper>
    </Template>
  );
};

export default Suporte;
